module.exports = __webpack_public_path__ + "static/media/typeUrl.5e8cf7ba.png";